import React from 'react';
import { Box } from '@material-ui/core';
import styled from 'styled-components';

const DetailColumn = styled(Box)`
    width: 100%;
    color: ${({ theme }) => theme.palette.primary.main};
    font-size: ${({ theme }) => theme.typography.body1.fontSize};
    line-height: 1.5;
    overflow-wrap: break-word;

    &.bold {
        font-weight: 700;
    }

    &.small {
        width: 100px;
    }

    &.descriptionColumn {
        color: ${({ theme }) => theme.palette.text.secondary};
    }

    span {
        font-weight: 400;
    }

    @media (min-width: ${({ theme }) =>
            `${theme.breakpoints.values['md']}px`}) {
        width: 50%;
        max-width: 300px;
    }
`;

interface IProps {
    bold?: boolean;
    className?: string;
    description?: string;
    small?: boolean;
}

const BaseDetailRow: React.FC<IProps> = ({
    bold,
    children,
    className,
    description,
    small,
}) => (
    <Box className={className}>
        {description && (
            <DetailColumn
                className={`descriptionColumn ${small ? 'small' : ''}`}
            >
                {description}
            </DetailColumn>
        )}

        <DetailColumn className={bold ? 'bold' : ''}>{children}</DetailColumn>
    </Box>
);

export const DetailRow = styled(BaseDetailRow)`
    width: 100%;
    margin-bottom: ${({ theme }) => `${theme.spacing(2)}px`};

    ${DetailColumn}:first-of-type {
        color: ${({ theme }) => theme.palette.text.disabled};
    }

    ${DetailColumn}:last-of-type {
        color: ${({ theme }) => theme.palette.text.primary};
    }

    @media (min-width: ${({ theme }) =>
            `${theme.breakpoints.values['md']}px`}) {
        display: flex;
    }
`;
